var render = function render() {
      var _vm = this,
          _c = _vm._self._c;return _c('el-dialog', _vm._b({ attrs: { "visible": _vm.addLocalResourceInZipDialog.visible }, on: { "update:visible": function updateVisible($event) {
                        return _vm.$set(_vm.addLocalResourceInZipDialog, "visible", $event);
                  } } }, 'el-dialog', _vm.dialog, false), [_vm.currentCategory && _vm.currentResourceInZip ? _c('image-uploader', { attrs: { "uploader": _vm.uploader, "meta-data": {
                        width: _vm.currentResourceInZip.width,
                        height: _vm.currentResourceInZip.height,
                        name: _vm.currentResourceInZip.name
                  } }, on: { "upload-success": _vm.handleUploadSuccess } }) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };